import { tns } from "tiny-slider";
window.addEventListener("DOMContentLoaded", () => {
  const readmore_btns = document.querySelectorAll(".bio .read-more");
  const fulltext = document.querySelectorAll(".bio .full-text");
  fulltext.forEach((item) => {
    item.setAttribute("style", `tooltip-height: ${item.scrollHeight}px`);
    window.addEventListener("resize", () => {
      item.style.height = "auto";
      item.setAttribute("style", `tooltip-height: ${item.scrollHeight}px`);
    });
  });

  readmore_btns.forEach((readmore) => {
    readmore.addEventListener("click", () => {
      readmore.parentElement.classList.add("hidden");
      const fulltext = readmore.parentElement.nextElementSibling;
      if (fulltext) {
        fulltext.classList.add("active");
      }
    });
  });

  //
  const bioEls = document.querySelectorAll(".staff .bio-container");

  const learnmore_btns = document.querySelectorAll(".staff .learn-more-btn");
  learnmore_btns.forEach((learnmore) => {
    learnmore.addEventListener("click", () => {
      let bioEl = learnmore.nextElementSibling;
      if (bioEl) {
        bioEl.classList.add("active");
      }
    });
  });

  const closeBioEls = document.querySelectorAll(".staff .close-bio");
  closeBioEls.forEach((closeBio) => {
    closeBio.addEventListener("click", () => {
      let bioEl = closeBio.parentElement;
      if (bioEl) {
        bioEl.classList.remove("active");
      }
    });
  });

  const video_links = document.querySelectorAll(".staff .video-click");
  if (video_links) {
    let video_popup_wrapper = document.createElement("div");
    video_popup_wrapper.classList.add("video-popup-wrapper");
    const body = document.querySelector("body");
    body.appendChild(video_popup_wrapper);
    video_popup_wrapper.addEventListener("click", (e) => {
      if (!e.target.closest("video")) {
        const video_popup = video_popup_wrapper.querySelector(".video-popup");
        console.log(video_popup);
        if (video_popup) {
          video_popup.remove();
          video_popup_wrapper.classList.remove("active");
        }
      }
    });
    video_links.forEach((link) => {
      link.addEventListener("click", () => {
        const video_popup = link.nextElementSibling;
        if (video_popup) {
          video_popup_wrapper.appendChild(video_popup.cloneNode(true));
          video_popup_wrapper.classList.add("active");
        }
      });
    });
  }

  //slider
  const reviewContainers = document.querySelectorAll(
    ".product-review-container"
  );
  reviewContainers.forEach((container) => {
    const sliderContainer = container.querySelector(".slider");
    const controlsContainer = container.querySelector(
      "#product-review-controls"
    );
    console.log(controlsContainer);
    const sliderVar = tns({
      container: sliderContainer,
      controlsContainer: controlsContainer,
      items: 1,
      nav: false,
      speed: 700,
      gutter: 16,
      responsive: {
        500: {
          items: 2,
        },
        992: {
          items: 3,
        },
      },
    });

    const nextBtn = container
      .querySelector('button[data-controls="next"]')
      ?.addEventListener("click", function () {
        // get slider info
        var info = slider.getInfo();
        var index = info.index;
        var total = info.slideCount;
        // get last slide that will be jumped back to the beginning on loop
        var lastSlide = info.slideItems[total + 1];

        // this prevents the animation from playing when the slider is jumped back to the beginning
        if (index == total * 2) {
          lastSlide.classList.add("anim-off");

          setTimeout(() => {
            lastSlide.classList.remove("anim-off");
          }, 800);
        }
      });
  });
});
